/* eslint-disable @typescript-eslint/no-unused-vars */
import { Devis, FactureFormalite } from '@europrocurement/l2d-domain';
import { createContext } from 'react';

const estimates: Array<Devis> = [];
const invoices: Array<FactureFormalite> = [];
const estimatesLoaded: boolean = false;
const invoicesLoaded: boolean = false;
const setReload: React.Dispatch<React.SetStateAction<boolean | undefined>> = () => {};
const updateActif = (actifDevis: boolean | undefined) => {};

const BillingContext = createContext({
    estimates,
    invoices,
    estimatesLoaded,
    invoicesLoaded,
    setReload,
    updateActif,
});

export default BillingContext;
